import { LinkButton } from "../LinkButton";

interface CtaButtonProps {
  label: string;
  url: string;
  color?: string;
  className?: string;
}

export const CtaButton = (props: CtaButtonProps) => {
  return (
    <LinkButton
      color={props.color ?? "white"}
      className={props.className}
      to={props.url}
      style={{
        border: `${props.color ?? "white"} 2px solid`,
        color: `${props.color ?? "white"}`,
        background: "none"
      }}
    >
      {props.label}
    </LinkButton>
  );
};
